<template>
    <div class="card card--shadow pa-0 h-100 overflow-hidden">
        <v-img :src="image" class="w-100"></v-img>
        <div class="pa-12 pa-md-24 text-center">
            <p class="page-text font-weight-bold">
                {{tit}}
            </p>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        image : {type :String, default : ""},
        tit : {type :String, default : ""},
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
</style>